if (!customElements.get('testimonials-slider')) {
  class TestimonialsSlider extends HTMLElement {
    constructor() {
      super()
      this.slider = this.querySelector('.swiper')
      this.sliderWrapper = this.slider?.querySelector('.swiper-wrapper')
      this.slides = [...this.slider?.querySelectorAll('.swiper-slide')]
      this.buttonPrev = this.querySelector('.swiper-button-prev')
      this.buttonNext = this.querySelector('.swiper-button-next')
      this.swiper = null

      this.createSlider()
    }

    createSlider() {
      const options = {
        loop: true,
        slidesPerView: 1.25,
        spaceBetween: 16,
        navigation: {
          prevEl: this.buttonPrev,
          nextEl: this.buttonNext,
          addIcons: false,
        },
      }

      this.swiper = new Swiper(this.slider, options)
    }
  }

  customElements.define('testimonials-slider', TestimonialsSlider)
}
